import React, { useEffect, useState } from 'react'
import { ReactComponent as InfoIcon } from '../../../assets/svg/InfoIcon.svg'
import { useTranslation } from 'react-i18next'
import CheckedCheckbox from './components/CheckedCheckbox'
import { alertRecipients } from './EmailSection'
import InfoButton from '../../common/InfoButton'

const PushSection = ({ settings, save }) => {
    const { t } = useTranslation()
    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState(settings?.push?.keywordsDetected ?? {})
    const [selectedEmotionOptions, setSelectedEmotionOptions] = useState(settings?.push?.multipleNegativeEmotions ?? {})

    useEffect(() => {
        if (!!settings) {
            setSelectedKeywordOptions(settings?.push?.keywordsDetected ?? {})
            setSelectedEmotionOptions(settings?.push?.multipleNegativeEmotions ?? {})
        }
    }, [settings])

    const handleSelection = (type, field) => {
        const data = {
            ...settings,
            push: {
                ...settings.push,
                [field]: {
                    ...settings.push[field],
                    [type]: !settings.push[field][type],
                },
            },
        }
        save(data)
        if (field === 'keywordsDetected') {
            setSelectedKeywordOptions(data?.push?.keywordsDetected ?? {})
        } else if (field === 'multipleNegativeEmotions') {
            setSelectedEmotionOptions(data?.push?.multipleNegativeEmotions ?? {})
        }
    }

    return (
        <div className="rounded-[10px] w-full h-full p-[32px] bg-white">
            <div>
                <div className="flex flex-row justify-between">
                    <p className="font-bold text-[24px] leading-[30px] text-darkenPurple">{t('pushNotifications')}</p>
                    <InfoButton text={t('Select who should receive push notifications for flagged keywords and for multiple consecutive uncomfortable emotions logged')} />
                </div>
                <p className="text-darkenPurple font-medium text-[16px] leading-5 mt-[12px] max-w-[50%]">
                    {t('Here you can manage who will receive the push notifications for different types of alerts')}
                </p>
            </div>
            <div className="flex flex-row justify-between">
                <div className="mt-[34px] max-w-[50%]">
                    <div className="flex flex-row gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Keyword alerts receipient(s) notifications')}</p>
                        <InfoButton text={t('Select who should receive push notifications when a student’s check-in includes flagged keywords')} />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedKeywordOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'keywordsDetected')}
                            />
                        </div>
                    ))}
                </div>
                <div className="max-w-[50%] mt-[34px] flex-1">
                    <div className="flex flex-row justify-between items-center gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Uncomfortable emotions receipient(s) notifications')}</p>
                        <InfoButton text={t('Select who should receive push notifications when students select uncomfortable emotions over multiple consecutive check-ins')} />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedEmotionOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'multipleNegativeEmotions')}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PushSection
